module.exports = __webpack_public_path__ + "img/img (8).d339077b.jpg";